<p-toast></p-toast>

<app-page-shell>

    <app-page-hero eyebrow="Workspace" title="AI Chat Assistant"
        subtitle="Ask operational questions across shipments, marketplace activity, billing, and support workflows.">
        <div nav class="ai-status-row">
            <p-tag value="Online" severity="success"></p-tag>
            <span>{{ messages().length }} messages in this conversation</span>
        </div>
        <div actions>
            <p-button label="Help Guide" icon="pi pi-question-circle" [outlined]="true" severity="secondary"></p-button>
            <p-button label="Clear History" icon="pi pi-trash" [outlined]="true" severity="danger"></p-button>
        </div>
    </app-page-hero>

    <div class="chat-workspace">
        <app-page-data-panel title="Active Conversation" subtitle="AI assistance for logistics and finance workflows.">
            <div actions>
                <p-button icon="pi pi-ellipsis-v" [text]="true" severity="secondary"
                    ariaLabel="Conversation options"></p-button>
            </div>

            <div class="conversation-card">
                <div class="messages-viewport" #chatMessages>
                    @for (message of messages(); track $index) {
                    <div class="message-row" [class.user]="message.sender.userRole === 'CUSTOMER'">
                        <div class="avatar" [class.user-avatar]="message.sender.userRole === 'CUSTOMER'">
                            <i
                                [class]="message.sender.userRole === 'CUSTOMER' ? 'pi pi-user' : 'fa-solid fa-robot'"></i>
                        </div>
                        <div class="message-stack">
                            <div class="message-bubble" [class.user-bubble]="message.sender.userRole === 'CUSTOMER'"
                                [innerHTML]="convertToHtml(message.textContent, !!message.sources?.length)">
                            </div>

                            @if (message.sources && message.sources.length > 0) {
                            <div class="message-sources" aria-label="Manual sources">
                                <span class="sources-label">Sources</span>
                                @for (source of message.sources; track source.manualId) {
                                <span class="source-tag">{{ source.pageTitle || source.module }}</span>
                                }
                            </div>
                            }

                            @if (message.actionButtons && message.actionButtons.length > 0) {
                            <div class="action-buttons">
                                @for (button of message.actionButtons; track button.payload) {
                                <p-button [label]="button.label" [severity]="$any(button.type) || 'secondary'"
                                    [outlined]="true" (click)="sendActionButton(button.payload)">
                                </p-button>
                                }
                            </div>
                            }

                            <span class="message-time">{{ message.timestamp | date:'shortTime' }}</span>
                        </div>
                    </div>
                    }

                    @if (isLoading()) {
                    <div class="message-row">
                        <div class="avatar">
                            <i class="fa-solid fa-robot"></i>
                        </div>
                        <div class="message-stack">
                            <div class="message-bubble typing-bubble">
                                <div class="typing-dots">
                                    <span></span><span></span><span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>

                <div class="chat-composer">
                    @if (isLoading()) {
                    <p-progressBar mode="indeterminate" styleClass="h-2px"></p-progressBar>
                    }
                    <div class="input-area">
                        <i class="pi pi-comment input-icon"></i>
                        <input type="text" pInputText [ngModel]="newMessage()" (ngModelChange)="newMessage.set($event)"
                            placeholder="Ask anything about shipments, quotes, or status..."
                            (keyup.enter)="sendMessage()" />
                        <p-button icon="pi pi-send" (click)="sendMessage()"
                            [disabled]="isLoading() || !newMessage().trim()" [rounded]="true" [text]="true"
                            severity="primary" ariaLabel="Send message">
                        </p-button>
                    </div>
                </div>
            </div>
        </app-page-data-panel>

        <div class="assistant-sidebar">
            <app-page-data-panel title="Available Skills" subtitle="Common assistant work areas.">
                <div class="skill-list">
                    <button type="button" class="skill-card">
                        <span class="skill-icon logistics"><i class="pi pi-truck"></i></span>
                        <span>
                            <strong>Logistics & Tracking</strong>
                            <small>Track shipments and manage Bayan regulatory compliance.</small>
                        </span>
                    </button>
                    <button type="button" class="skill-card">
                        <span class="skill-icon market"><i class="pi pi-shopping-cart"></i></span>
                        <span>
                            <strong>Marketplace Operations</strong>
                            <small>Search for loads, place bids, and handle load requests.</small>
                        </span>
                    </button>
                    <button type="button" class="skill-card">
                        <span class="skill-icon finance"><i class="pi pi-wallet"></i></span>
                        <span>
                            <strong>Financial Services</strong>
                            <small>Manage billing accounts, payments, and invoices.</small>
                        </span>
                    </button>
                    <button type="button" class="skill-card">
                        <span class="skill-icon support"><i class="pi pi-user"></i></span>
                        <span>
                            <strong>Support Takeover</strong>
                            <small>Request assistance from a human agent at any time.</small>
                        </span>
                    </button>
                </div>
            </app-page-data-panel>

            <section class="system-tip">
                <div>
                    <i class="pi pi-info-circle"></i>
                    <strong>System Tip</strong>
                </div>
                <p>You can ask the AI to "Find my latest shipment" or "Show me the delivery status of PRJ-24-001" for
                    instant results.</p>
            </section>
        </div>
    </div>
</app-page-shell>
